export default __webpack_public_path__ + "static/media/guide0205.6b25e65c.jpg";